import React from 'react';

export const UserFormContext = React.createContext({});

export const useUserFormContext = () => React.useContext(UserFormContext);
